import "../../config"
import * as API from "../URL";
import axiosInstance from "../../services/axiosInstance";

export const getAllTranslations = async () => {
  const fetchData = await fetch(API.getAllTranslations, {
    method: "GET",
    headers: JSON.parse(JSON.stringify({
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*"
    }))
  })
  return await fetchData.json();
}

export const getTranslation = async (lng, ns) => {
  const { data } = await axiosInstance.get("/api/i18n/translations", {
    params: { lang: lng, namespace: ns },
  });
  return data.data;
};

export const updateTranslation = async (lng, ns, data) => {
  const fetchData = await fetch(API.translationUrl(lng, ns), {
    method: "PATCH",
    headers: JSON.parse(JSON.stringify({
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*",
    })),
    body: JSON.stringify(data)
  })
  return await fetchData.json();
}

export const addNewTranslations = async (lng,ns,data) => {
  const fetchData = await fetch(API.addNewTranslations(lng,ns), {
    method: "PATCH",
    headers: JSON.parse(JSON.stringify({
      "content-Type": "application/json",
      Accept: "*/*",
      "Access-Control-Allow-Origin": "*"
    })),
    body: JSON.stringify(data)
  })
  return await fetchData.json();
}
